import setLocation from './set-location';

export default {
  setLocation,
};
